import { render, staticRenderFns } from "./OptionForm.vue?vue&type=template&id=37e68fae"
import script from "./OptionForm.vue?vue&type=script&lang=js"
export * from "./OptionForm.vue?vue&type=script&lang=js"
import style0 from "./OptionForm.vue?vue&type=style&index=0&id=37e68fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports